<template>
  <div>
    <h2 class="black--text">Dokumentasi Kegiatan</h2>
    <v-row v-if="tipe === 'box'">
      <template v-for="(foto, id) in berkases">
        <v-col :key="id" cols="12" lg="4">
          <v-img class="my-2" :src="foto"></v-img>
          <span class="body-2">Foto Kegiatan</span>
        </v-col>
      </template>
    </v-row>
    <v-list v-else>
      <v-list-item class="px-0" v-for="(berkas, id) in berkases" :key="id">
        <v-list-item-content class="py-2">
          <span class="px-0 body-2 grey--text" style="height: 24px;"> Dokumentasi {{ id + 1 }} </span>
          <div :class="['black--text', 'grey lighten-3 pa-3']" style="border-radius: 5px">
            <a :href="berkas" target="_blank"> Lihat Berkas Dokumentasi {{ id + 1 }} </a>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'DokumentasiFoto',
  props: {
    berkases: {
      type: Array,
      default: () => [],
    },
    tipe: {
      type: String,
      default: 'box',
    },
  },
};
</script>

<style scoped></style>
